import { Facebook, Instagram, Twitter } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <div className="md:p-14 p-6">
      <div className="flex items-center justify-between gap-6 lg:gap-20  border-t border-t-[#66666640] border-b border-b-[#66666640] flex-col lg:flex-row">
        <div className=" flex items-start justify-center flex-col ">
          <img
            src="/assets/Jellosite-Logo-09.jpg"
            alt=""
            className="w-35 -ml-6"
          />
          <span className=" responsive-font-span text-[#737373] wrap-normal">
            JelloSite empowers individuals and businesses across the country,
            providing the tools they need to amplify their presence and build
            trust online
          </span>
          <div className="flex items-center justify-center gap-4 my-4 sm:my-9">
            <Link to="https://x.com/jellosite" target="_blank">
              <Twitter color="#7E57C2" fill="#7E57C2" />
            </Link>
            <Link to="https://instagram.com/jellosite" target="_blank">
              <Instagram color="#7E57C2" />
            </Link>
            <Link to="https://www.facebook.com/people/Jellosite/61571769805212/" target="_blank">
              <Facebook color="#7E57C2" fill="#7E57C2" />
            </Link>
          </div>
        </div>
        <div className=" flex items-start sm:flex-row flex-col gap-9 mb-9 justify-start lg:justify-center sm:gap-[20%] w-full ">
          <ul className="flex items-start justify-center gap-1.5 flex-col">
            <h5 className=" font-medium text-[#7E57C2]">Company</h5>
            <Link to="/pricing">
              <li className="text-sm text-[#666666]">Pricing</li>
            </Link>
            <Link to="/terms_conditions">
              <li className="text-sm text-[#666666]">Terms of Service</li>
            </Link>
            <Link to="/privacy_policy">
              <li className="text-sm text-[#666666]">Privacy Policy</li>
            </Link>
          </ul>
          <ul className="flex items-start justify-center gap-1.5 flex-col">
            <h5 className=" font-medium text-[#7E57C2]">About Us</h5>
            <Link to="/about">
              <li className="mt-2 text-sm text-[#666666]">About</li>
            </Link>
            <li>
              <a href="/#faq" className="text-sm text-[#666666]">
                FAQ's
              </a>
            </li>
          </ul>
          <ul className="flex items-start justify-center gap-1.5 flex-col">
            <h5 className=" font-medium text-[#7E57C2]">Contact Us</h5>
            <a
              href="mailto:info@jellosite.com"
              type="email"
              className="text-sm text-[#666666]"
            >
              info@jellosite.com
            </a>
            <li className="text-sm text-[#666666]">Abuja,Nigeria</li>
          </ul>
        </div>
      </div>
      <div className="flex gap-14 mt-8">
        <span className="responsive-font-span text-[#737373]">
          @Copyright Jellosite Inc. 2025
        </span>
        <ul className="flex gap-6 list-none">
          <Link to="/privacy_policy">
            <li className="text-sm text-[#666666]">Privacy Policy</li>
          </Link>
          <Link to="/terms_conditions">
            <li className="text-sm text-[#666666]">Terms</li>
          </Link>
        </ul>
      </div>
    </div>
  );
};
